import * as React from 'react';

export class MonitoringWhiteSvg extends React.Component<{}> {
  
  render() {
    return (
      <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32.6665 20.1172V37.6259L35.9998 35.2477V22.4971L32.6665 20.1172Z" fill="white"/>
        <path d="M24.4698 14.6094H24.3331V37.6253L27.6665 35.2471V16.8908L24.4698 14.6094Z" fill="white"/>
        <path d="M16.1365 23.1035H15.9999V38.1355L19.3332 35.7573V25.3849L16.1365 23.1035Z" fill="white"/>
        <path d="M7.6665 6.52734V38.307L10.9998 35.9271V8.90725L7.6665 6.52734Z" fill="white"/>
      </svg>
    )
  }
}